<template>
  <div class="instructor-inline-form">
    <template v-if="mode === INLINE_FORM_MODE.FORM">
      <el-form
        :model="form"
        :rules="formValidateRules"
        label-position="top"
        label-width="100px"
        @validate="onValidateChange"
      >
        <el-row :gutter="10">
          <el-col
            :sm="24"
            :md="6"
          >
            <el-form-item prop="name">
              <el-input
                v-model="form.name"
                placeholder="성함"
              />
            </el-form-item>
          </el-col>

          <el-col
            :sm="24"
            :md="6"
          >
            <el-form-item prop="email">
              <el-input
                v-model="form.email"
                type="email"
                placeholder="이메일"
              />
            </el-form-item>
          </el-col>

          <el-col
            :sm="24"
            :md="6"
          >
            <el-form-item prop="phone_number">
              <el-input
                v-model="form.phone_number"
                placeholder="휴대전화번호"
              />
            </el-form-item>
          </el-col>

          <el-col
            :sm="24"
            :md="6"
          >
            <el-button
              class="btn-save"
              :disabled="!isFormValidated"
              @click="handleClickSaveForm"
            >
              저장
            </el-button>
            <el-button
              class="btn-cancel"
              @click="handleClickCancelForm"
            >
              취소
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template v-if="mode === INLINE_FORM_MODE.VIEW">
      <div class="instructor-view">
        <div class="instructor-control">
          <span @click="handleClickEdit">수정</span> <div class="vr">
            |
          </div>
          <span @click="handleClickDelete">삭제</span>
        </div>
        <span class="instructor-name">{{ form.name }}</span>
        <div class="instructor-detail-info">
          <span>{{ form.email }}</span> <div class="vr">
            |
          </div>
          <span>{{ form.phone_number }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
	validateName,
	validateEmailOnInstructor,
	validatePhoneNum,
} from "@/utils/form-validate-rules";
import { INLINE_FORM_MODE } from "@/constants";

export default {
	name: "InstructorInlineForm",
	props: {
		index: {},
		data: {},
		mode: {},
	},
	data() {
		return {
			INLINE_FORM_MODE,
			form: {
				id: null,
				name: "",
				email: "",
				phone_number: "",
			},
			store: {
				name: '',
				email: '',
				phone_number: '',
			},
			formValidateRules: {
				name: [{ validator: validateName, trigger: "change" }],
				email: [{ validator: undefined, trigger: "change" }],
				phone_number: [{ validator: validatePhoneNum, trigger: "change" }],
			},
			isFormValid: {
				name: false,
				email: false,
				phone_number: false,
			},
		};
	},
	computed: {
		isFormValidated() {
			return this.validateForm();
		},
	},
	created() {
		if (this.data) {
			this.formValidateRules.email[0].validator = this.validateEmailOnUpdateInstructor;
			this.form = this.data;
			this.isFormValid.name = true;
			this.isFormValid.email = true;
			this.isFormValid.phone_number = true;
			
			this.store = {
				...this.form
			}
		}else{
			this.formValidateRules.email[0].validator = validateEmailOnInstructor;
		}
	},
	methods: {
		validateForm() {
			return Object.values(this.isFormValid).every(i => i);
		},
		onValidateChange($event, isValidated) {
			this.isFormValid[$event] = isValidated;
		},
		handleClickSaveForm() {
			if (this.form.id) {
				return this.$emit("update", this.form);
			}

			this.$emit("create", this.form);
		},
		handleClickEdit() {
			this.$emit("changeMode", {
				id: this.form.id,
				mode: INLINE_FORM_MODE.FORM,
			});
		},
		handleClickDelete() {
			this.$emit("delete", {
				id: this.form.id,
			});
		},
		handleClickCancelForm() {
			this.form = {
				...this.store
			}			
			this.$emit("changeMode", {
				id: this.form.id,
				mode: INLINE_FORM_MODE.VIEW,
			});
		},
		validateEmailOnUpdateInstructor(rule, value, callback, ...args){
			if(this.store.email === value){
				return callback();
			}else{
				return validateEmailOnInstructor(rule, value, callback, ...args);
			}
		}
	},
};
</script>

<style lang="scss">
.instructor-inline-form {
	margin-bottom: 10px;
	border-radius: 6px;
	box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.19);
	background-color: #f2f2f2;
	border: solid 1px #d3d3d3;
	padding: 17px 15px 11px;
	color: #4a4a4a;
	box-sizing: border-box;

	.el-form.el-form--label-top {
		padding: 0;

		.el-form-item {
			margin: 0;

			&.is-error {
				padding-bottom: 15px;
			}
		}

		.el-button {
			float: right;
			width: 65px;
			height: 42px;
			border-radius: 8px;
			font-weight: normal;
			margin-top: 4px;
			margin-left: 10px;
		}

		.btn-save {
			background-color: #9b9b9b;
			border: solid 1px #d3d3d3;
			color: white;
		}

		.btn-cancel {
			background-color: #f0f0f0;
			border: solid 1px #d3d3d3;
		}

		@media screen and (max-width: 768px) {
			.el-form-item {
				margin-bottom: 5px;
			}
		}
	}

	.instructor-view {
		position: relative;

		.instructor-control {
			position: absolute;
			top: -1;
			right: 0;
			font-size: 12px;
			font-weight: 500;
			text-align: right;
			color: #9b9b9b;

			span:hover {
				text-decoration: underline;
				cursor: pointer;
			}
		}

		.instructor-name {
			height: 20px;
			font-size: 16px;
			font-weight: 600;
			line-height: 20px;
		}

		.instructor-detail-info {
			margin-top: 6px;
			margin-bottom: 4px;
			font-size: 14px;
			font-weight: normal;
			line-height: 20px;
		}
	}
}
</style>
